import { params, string } from '@thd-nucleus/data-sources';

export const storeDirectoryByStateModel = {
  storeDirectoryByState: params({ state: string().isRequired() }).shape({
    stateName: string()
  })
};